import { useEffect, useRef, useState } from 'react';

/** Counts down from `seconds` once started. Done is always available; the timer never judges. */
export function useCountdown(seconds: number, startedAt: number | null, onZero?: () => void) {
  const [now, setNow] = useState(() => Date.now());
  const fired = useRef(false);
  useEffect(() => {
    if (!startedAt) return;
    const id = setInterval(() => setNow(Date.now()), 250);
    return () => clearInterval(id);
  }, [startedAt]);
  const elapsed = startedAt ? Math.max(0, (now - startedAt) / 1000) : 0;
  const remaining = Math.max(0, seconds - elapsed);
  // Reset on a new start, or a second run of the same exercise never rings:
  // the component does not remount between them, so the ref survives and
  // `fired` is still true from the first run.
  useEffect(() => { fired.current = false; }, [startedAt]);
  useEffect(() => {
    if (startedAt && remaining === 0 && !fired.current) { fired.current = true; onZero?.(); }
  }, [remaining, startedAt, onZero]);
  return { elapsed, remaining };
}

export function mmss(sec: number): string {
  const m = Math.floor(sec / 60);
  const s = Math.floor(sec % 60);
  return `${m}:${String(s).padStart(2, '0')}`;
}
